import Swal from 'sweetalert2';

$(function () {

    /**
     * UPDATE QUANTITY
     */

    $(document).on('submit', '.js__update_cart_quantity', (e) => {
        e.preventDefault();

        $.ajax({
            'url': $(e.target).attr('action'),
            'type': 'POST',
            'data': $(e.target).serialize(),
            'success': function (data) {
                if (data.success) {
                    var summary = $('.cart__summary');
                    var productCard = $(e.currentTarget).closest('.product__card');
                    var producerCard = $(e.currentTarget).closest('.cart__lines__line');
                    var cartLines = $(e.currentTarget).closest('.cart__lines');
                    var warnings = productCard.siblings('.cart__amount__warning');
                    var informations = productCard.siblings('.block-cart__image__content');
                    summary.replaceWith(data.summary);
                    productCard.replaceWith(data.cartLine);
                    warnings.replaceWith(data.warnings);
                    informations.replaceWith(data.informations);
                    if(producerCard.find($('.lessmin')).length > 0) {
                        producerCard.addClass('warning');
                    } else {
                        producerCard.removeClass('warning');
                    }
                    if (data.cartCount > 0) {
                        $('.js__cart_count').removeClass('hide');
                        $('.js__cart_count').html(data.cartCount);
                    } else {
                        $('.js__cart_count').addClass('hide');
                        productCard.remove();
                        cartLines.html('<div>' + data.emptyMessage + '</div>');
                    }
                    if(data.message) {
                        $('.messages').html('<div class="alert alert-info"><ul><li>'+data.message+'</li></ul></div>');
                    }
                } else {
                    console.error(data);
                }
            },
            'error': function (e) {
                console.error('Something wrong!', e);
            }
        });
    });

    /**
     * FIN - UPDATE QUANTITY
     */


    /**
     * REMOVE ITEM
     */

    $(document).on('submit', '.js__remove_cart_item', (e) => {
        e.preventDefault();

        $.ajax({
            'url': $(e.target).attr('action'),
            'type': 'DELETE',
            'data': $(e.target).serialize(),
            'success': function (data) {
                if (data.success) {
                    var summary = $('.cart__summary');
                    var productCard = $(e.currentTarget).closest('.product__card');
                    var producerCard = $(e.currentTarget).closest('.cart__lines__line');
                    var cartLines = $(e.currentTarget).closest('.cart__lines');
                    var warnings = productCard.siblings('.cart__amount__warning');
                    var informations = productCard.siblings('.block-cart__image__content');
                    summary.replaceWith(data.summary);
                    warnings.replaceWith(data.warnings);
                    informations.replaceWith(data.informations);
                    if(producerCard.find($('.lessmin')).length > 0) {
                        producerCard.addClass('warning');
                    } else {
                        producerCard.removeClass('warning');
                    }
                    productCard.remove();
                    if (producerCard.find('.product__card').length === 0) {
                        producerCard.remove();
                    }
                    if (cartLines.find('.cart__lines__line').length === 0) {
                        cartLines.html('<div>' + data.emptyMessage + '</div>');
                    }
                    if (data.cartCount > 0) {
                        $('.js__cart_count').removeClass('hide');
                        $('.js__cart_count').html(data.cartCount);
                    } else {
                        $('.js__cart_count').addClass('hide');
                    }
                } else {
                    console.error(data);
                }
            },
            'error': function (e) {
                console.error('Something wrong!', e);
            }
        });
    });

    $(document).on('submit', '.js__remove_cart_items', (e) => {
        e.preventDefault();

        Swal.fire({
            title: attention,
            text: questionProducer,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: confirm,
            cancelButtonText: cancel,
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    'url': $(e.target).attr('action'),
                    'type': 'DELETE',
                    'data': $(e.target).serialize(),
                    'success': function (data) {
                        if (data.success) {
                            var summary = $('.cart__summary');
                            var productCard = $(e.currentTarget).closest('.product__card');
                            var producerCard = $(e.currentTarget).closest('.cart__lines__line');
                            var cartLines = $(e.currentTarget).closest('.cart__lines');
                            var warnings = productCard.siblings('.cart__amount__warning');
                            var informations = productCard.siblings('.block-cart__image__content');
                            summary.replaceWith(data.summary);
                            warnings.replaceWith(data.warnings);
                            informations.replaceWith(data.informations);
                            productCard.remove();
                            producerCard.remove();
                            if (cartLines.find('.cart__lines__line').length === 0) {
                                cartLines.html('<div>' + data.emptyMessage + '</div>');
                            }
                            if (data.cartCount > 0) {
                                $('.js__cart_count').removeClass('hide');
                                $('.js__cart_count').html(data.cartCount);
                            } else {
                                $('.js__cart_count').addClass('hide');
                            }
                        } else {
                            console.error(data);
                        }
                    },
                    'error': function (e) {
                        console.error('Something wrong!', e);
                    }
                });
            }
        })
    });

    /**
     * FIN - REMOVE ITEM
     */


    /**
     * ADDRESSES
     */

    $(document).on('click', '#same_address_billing', function (e) {
        if ($('#same_address_billing:checked').val()) {
            $('#billing_address').addClass('hide');
        } else {
            $('#billing_address').removeClass('hide');
        }
    });

    /**
     * FIN - ADDRESSES
     */


    /**
     * RELAIS MAP
     */

    $(document).on('click', '.selectRelais', function (e) {
        e.preventDefault();
        var relais_id = $(this).data('relais');
        var nom = $(this).data('enseigne');
        var address = $(this).data('address');
        var postal = $(this).data('postalcode');
        var city = $(this).data('city');

        var html = nom + "<br/>" + address + "<br/>" + postal + " " + city;

        $('#relais_id').val(relais_id);
        $('.relais_address').html(html);
        $('.relais_selected').removeClass('hide');
        $('.cart__summary__map').removeClass('alert');
        $('.cart__summary__map__danger').addClass('hide');
        $('.cart__action .button').removeAttr('disabled');
    });

    $(document).on('click', '.showhoraires', function (e) {
        e.preventDefault();
        $('.relaishoraires').addClass('hide');
        $(this).parent().find('.relaishoraires').removeClass('hide');
    });

    $(document).on('change', '.shipping_method', function (e) {
        e.preventDefault();
        var chronorelais = $('.shipping_method[data-code="chronorelais"]:checked');
        if (chronorelais.length === 0) {
            $('.cart__summary__map').addClass('hide');
            $('.cart__summary__map__danger').addClass('hide');
            $('.cart__action .button').removeAttr('disabled');
        } else {
            $('.cart__summary__map').removeClass('hide');
            if (!$('input[name="relais_id"]').val()) {
                $('.cart__summary__map').addClass('alert');
                $('.cart__summary__map__danger').removeClass('hide');
                $('.cart__action .button').prop('disabled', true);
            }else{
                $('.cart__summary__map').removeClass('alert');
                $('.cart__summary__map__danger').addClass('hide');
                $('.cart__action .alert').addClass('hide');
                $('.cart__action .button').removeAttr('disabled');
            }
        }
    });

    /**
     * FIN - RELAIS MAP
     */


    /**
     * WALLET
     */

    $('input[name="wallet"][data-left-to-pay="0"]').on('change', function (e) {
        if (this.checked) {
            $('.cart__payment_methods').addClass('disabled');
        } else {
            $('.cart__payment_methods').removeClass('disabled');
        }
    });

    /**
     * FIN - WALLET
     */

    /**
     * ADD PROMOTION FORM
     */

    $('input[name="code"]').on('input', function (e) {
        if ($(this).val() == '') {
            $(this).next('button').attr('disabled', 'disabled');
        } else {
            $(this).next('button').removeAttr('disabled');
        }
    }).trigger('input');

    /**
     * FIN - ADD PROMOTION FORM
     */

});

